import React from 'react'
import Navbar from './Navbar'
import AboutUs from './AboutUs'
import Neft from './Neft'
import Atm from './Atm'
import ContactUs from './ContactUs'
import Banner from './Banner'
import Scroll from './Scroll'
import GetTouch from './GetTouch'
import NavHead from './SubNav'
import CoreBank from './CoreBank'

function Landing() {
  return (
    <div>
        <NavHead/>
        <Navbar/>
        <Banner/>
        <Scroll/>
        <AboutUs/>
        <CoreBank/>
        <Neft/>
        <GetTouch/>
        {/* <Atm/> */}
        <ContactUs/>

    </div>
  )
}

export default Landing